// 购物车——主流程
const MainRoutes = Array.from({ length: 8 }, (_, i) => ({
  path: `icon/shoppingCart/index${i + 1}`,
  name: `icon/shoppingCartIndex${i + 1}`,
  component: () => import(`@/views/recognize/icon/shoppingCart/index${i + 1}.vue`)
}))



export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 购物车——主流程，开始
    ...MainRoutes,
  ],
};
